module.exports = __webpack_public_path__ + "static/sa-479bb907f17a17b69478443d24027a6c.svg";